import { z } from 'zod'

import { themeSchema } from '@ems/theme/contract'

import { api } from '#admin/lib/api-client.ts'

const contrastIssueSchema = z.object({
  mode: z.enum(['light', 'dark']),
  pair: z.string(),
  ratio: z.number(),
  required: z.number(),
})

const themeResponseSchema = z.object({
  theme: themeSchema,
  warnings: z.array(contrastIssueSchema),
})

export type ThemeResponse = z.infer<typeof themeResponseSchema>

export function fetchTheme(signal?: AbortSignal): Promise<ThemeResponse> {
  return api.get('/v1/tenant/theme', { schema: themeResponseSchema, ...(signal ? { signal } : {}) })
}

export function publishTheme(theme: z.infer<typeof themeSchema>): Promise<ThemeResponse> {
  return api.put('/v1/admin/tenant/theme', { schema: themeResponseSchema, body: theme })
}
